import axios from 'axios';
// 保存测评等级
export function saveAccessLevel(data) {
  return axios({
    url: '/fyAccess/saveAccessLevel',
    method: 'POST',
    data: data,
  });
}
// 删除测评等级
export function delAccessLevel(data) {
  return axios({
    url: '/fyAccess/delAccessLevel',
    method: 'POST',
    data: data,
  });
}

// 获取考核初始分数
export function getAccessScore(params) {
  return axios({
    url: '/fyAccess/getAccessScore',
    method: 'GET',
    params: params,
  });
}

// 考核初始分数设置
export function saveAccessScore(data) {
  return axios({
    url: '/fyAccess/saveAccessScore',
    method: 'POST',
    data: data,
  });
}

// 保存评测项目
export function saveAccessProject(data) {
  return axios({
    url: '/fyAccess/saveAccessProject',
    method: 'POST',
    data: data,
  });
}

// 删除评测项目
export function delAccessProject(data) {
  return axios({
    url: '/fyAccess/delAccessProject',
    method: 'POST',
    data: data,
  });
}

// 保存评测项目细则
export function saveAccessItem(data) {
  return axios({
    url: '/fyAccess/saveAccessItem',
    method: 'POST',
    data: data,
  });
}

// 删除评测项目细则
export function delAccessItem(data) {
  return axios({
    url: '/fyAccess/delAccessItem',
    method: 'POST',
    data: data,
  });
}

// 搜索下拉选
export function selectionList(params) {
  return axios({
    url: '/fyAccess/selectionList',
    method: 'GET',
    params: params,
  });
}

// 学生查询
export function searchStudent(params) {
  return axios({
    url: '/fyAccess/searchStudent',
    method: 'GET',
    params: params,
  });
}
// 保存测评记录(school:fyAccess:saveAccessRecord)
export function saveAccessRecord(data) {
  return axios({
    url: '/fyAccess/saveAccessRecord',
    method: 'POST',
    data: data,
  });
}

// 评测记录导出
export function exportAccessRecord(params) {
  return axios({
    url: '/fyAccess/exportAccessRecord',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}
// 删除测评记录(school:fyAccess:delAccessRecord)
export function delAccessRecord(data) {
  return axios({
    url: '/fyAccess/delAccessRecord',
    method: 'POST',
    data: data,
  });
}

// 测评统计导出(school:fyAccess:exportAccessStatistics)
export function exportAccessStatistics(params) {
  return axios({
    url: '/fyAccess/exportAccessStatistics',
    method: 'GET',
    params: params,
    responseType: 'blob',
  });
}

// 测评统计图(school:fyAccess:accessStatisticsChart)
export function accessStatisticsChart(params) {
  return axios({
    url: '/fyAccess/accessStatisticsChart',
    method: 'GET',
    params: params,
  });
}

// 测评统计图导出(school:fyAccess:accessStatisticsChartExport)
export function accessStatisticsChartExport(params) {
  return axios({
    url: '/fyAccess/accessStatisticsChartExport',
    method: 'GET',
    params: params,
    responseType: 'blob'
  });
}
